const FilterPlus = ({ ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.7725 8.73H9.855V5.8125C9.855 5.50125 9.60375 5.25 9.2925 5.25C8.98125 5.25 8.73 5.50125 8.73 5.8125V8.73H5.8125C5.50125 8.73 5.25 8.98125 5.25 9.2925C5.25 9.60375 5.50125 9.855 5.8125 9.855H8.73V12.7725C8.73 13.0837 8.98125 13.335 9.2925 13.335C9.60375 13.335 9.855 13.0837 9.855 12.7725V9.855H12.7725C13.0838 9.855 13.335 9.60375 13.335 9.2925C13.335 8.98125 13.0838 8.73 12.7725 8.73Z"
      fill="#646464"
    />
  </svg>
)

export default FilterPlus
